const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const LOGIN_ACTION = "LOGIN";
const SIGNUP_ACTION = "SIGN_UP";
const LOGOUT_ACTION = "LOGOUT";
const UPDATE_HISTORY_ACTION = "UPDATE_HISTORY";
const UPDATE_WATCH_LATER_ACTION = "UPDATE_WATCH_LATER";
const UPDATE_LIKES_ACTION = "UPDATE_LIKES";
const UPDATE_PLAYLISTS_ACTION = "UPDATE_PLAYLISTS";
const UPDATE_PLAYLIST_ACTION = "UPDATE_PLAYLIST";

export {
  EMAIL_REGEX,
  LOGIN_ACTION,
  SIGNUP_ACTION,
  LOGOUT_ACTION,
  UPDATE_HISTORY_ACTION,
  UPDATE_WATCH_LATER_ACTION,
  UPDATE_LIKES_ACTION,
  UPDATE_PLAYLISTS_ACTION,
  UPDATE_PLAYLIST_ACTION,
};
